import React from 'react';
import { Link } from 'react-router-dom';

export function About() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <h1 className="font-outfit text-3xl font-semibold mb-8 flex items-center gap-3 text-pearl-white relative after:absolute after:bottom-0 after:left-0 after:w-24 after:h-px after:bg-gradient-to-r after:from-naia-pink after:to-transparent">
        <span>About Naia</span>
      </h1>

      <div className="space-y-8">
        <section className="bg-white/5 rounded-xl p-6">
          <h2 className="text-xl font-outfit font-semibold mb-4 text-pearl-white">About</h2>
          <div className="prose prose-invert">
            <p>
              Naia is a streaming service optimized for VSynth music, letting you listen to your favorite VSynth producers wherever you are.
            </p>
            <p className="text-slate-grey">Version: 0.2.1</p>
            <p className="text-slate-grey">© 2025 Naia. All rights reserved.</p>
          </div>
        </section>

        <section className="bg-white/5 rounded-xl p-6">
          <h2 className="text-xl font-outfit font-semibold mb-4 text-pearl-white">Legal</h2>
          <div className="space-y-3">
            <div>
              <Link 
                to="/privacy" 
                className="text-naia-pink hover:text-soft-violet transition-colors text-lg font-medium"
              >
                Privacy Policy
              </Link>
              <p className="text-slate-grey text-sm mt-1">
                Learn how we collect, use, and protect your personal information.
              </p>
            </div>
            <div>
              <Link 
                to="/terms" 
                className="text-naia-pink hover:text-soft-violet transition-colors text-lg font-medium"
              >
                Terms of Service
              </Link>
              <p className="text-slate-grey text-sm mt-1">
                Review the terms and conditions for using Naia.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-white/5 rounded-xl p-6">
          <h2 className="text-xl font-outfit font-semibold mb-4 text-pearl-white">Third-Party Licenses</h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-pearl-white mb-2">React & React DOM</h3>
              <p className="text-slate-grey">MIT License</p>
              <p className="text-sm text-slate-grey">
                A JavaScript library for building user interfaces.
                Copyright (c) Meta Platforms, Inc. and affiliates.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-pearl-white mb-2">Material-UI & Emotion</h3>
              <p className="text-slate-grey">MIT License</p>
              <p className="text-sm text-slate-grey">
                React components that implement Google's Material Design.
                Copyright (c) 2014-2023 Call-Em-All.
                Includes @emotion/react, @emotion/styled, and @mui/icons-material.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-pearl-white mb-2">TanStack Query</h3>
              <p className="text-slate-grey">MIT License</p>
              <p className="text-sm text-slate-grey">
                Powerful asynchronous state management for React.
                Copyright (c) 2019-present Tanner Linsley.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-pearl-white mb-2">React Router DOM</h3>
              <p className="text-slate-grey">MIT License</p>
              <p className="text-sm text-slate-grey">
                Declarative routing for React web applications.
                Copyright (c) React Training LLC 2015-2019.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-pearl-white mb-2">Chart.js & React Integration</h3>
              <p className="text-slate-grey">MIT License</p>
              <p className="text-sm text-slate-grey">
                Simple yet flexible JavaScript charting library.
                Includes react-chartjs-2 for React integration and chartjs-adapter-date-fns for date handling.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-pearl-white mb-2">Google OAuth & Sentry</h3>
              <p className="text-slate-grey">MIT License</p>
              <p className="text-sm text-slate-grey">
                @react-oauth/google for Google authentication integration.
                @sentry/browser and @sentry/react for error monitoring and performance tracking.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-pearl-white mb-2">Tauri</h3>
              <p className="text-slate-grey">Apache License 2.0 / MIT License</p>
              <p className="text-sm text-slate-grey">
                Framework for building desktop applications with web technologies.
                Copyright (c) 2019-2023 Tauri Programme within The Commons Conservancy.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-pearl-white mb-2">Date & Utility Libraries</h3>
              <p className="text-slate-grey">MIT License</p>
              <p className="text-sm text-slate-grey">
                date-fns: Modern JavaScript date utility library.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-pearl-white mb-2">Development Tools</h3>
              <p className="text-slate-grey">MIT License / Apache License 2.0</p>
              <p className="text-sm text-slate-grey">
                Vite: Next generation frontend tooling with @vitejs/plugin-react.
                TypeScript: Typed superset of JavaScript (Apache 2.0).
                ESLint & plugins: JavaScript linting tools.
                Tailwind CSS with @tailwindcss/forms and @tailwindcss/typography plugins.
                PostCSS & Autoprefixer: CSS processing tools.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-pearl-white mb-2">Testing & Build Tools</h3>
              <p className="text-slate-grey">MIT License</p>
              <p className="text-sm text-slate-grey">
                Vitest: Vite-native testing framework.
                @testing-library/react: Simple and complete testing utilities.
                Playwright: End-to-end testing framework.
                Wrangler: Cloudflare Workers development tool.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
} 